<div class="row main-schedule" id="mainSchedule">
  <div class="col s12 m12 l4 xl3 remove-default-padding" id="leftContainer">
    <div class="left-container left-col">
      <h2 id="instruct-h2">Instructions</h2>
      <p class="justify" id="instructContent">
        {{operators.Add ? createIntro : ''}} {{intro}}
      </p>
      <div class="createBtn align-center">
        <button kendoButton (click)="createNewSchedule()" id="create-schedule" [primary]="true" *ngIf="operators.Add"
          class="background-red border-red"><span class='k-icon k-i-plus'></span>Create New
          Schedule</button>
      </div>
      <div class="stroke-separator"></div>
      <div class="row">
        <div class="col m3 l6 xl7">
          <h2 id="schedule-list">Schedule List</h2>
        </div>
        <div class="col m2 l6 xl5">
          <kendo-dropdownlist [popupSettings]="{ popupClass: 'font-size-16 text-black nova-font-style' }"
            [data]="fiscalYearList" [(ngModel)]="currentFy" name="fiscalYear" class="left-margin-5"
            (selectionChange)="fiscalYearChange($event)" id="fiscal-year">
          </kendo-dropdownlist>
        </div>
      </div>
      <div class="panel-bar-view">
        <kendo-tabstrip [animate]="true" [tabAlignment]="'justify'" #tabstrip [hidden]="initialLoading">
          <kendo-tabstrip-tab *ngFor="let item of fySchedule let i=index" [title]="item.id" [selected]="i == 0">
            <ng-template kendoTabContent>
              <div class="padding-5">
                <span class="bold">{{item.heading}}{{item.id}}</span>
              </div>
              <div *ngIf="item.data.length === 0" class="padding-10">
                <span>No schedule found</span>
              </div>
              <div *ngIf="item.data.length > 0">
                <kendo-panelbar>
                  <kendo-panelbar-item [title]="dataItem.payScheduleName" *ngFor="let dataItem of item.data"
                    id="{{dataItem.id}}" [expanded]="selectedid === dataItem.id">
                    <ng-template kendoPanelBarContent>
                      <div class="row bottom-margin-0">
                        <div class="col s12 m6 l6 xl5 remove-default-padding">
                          <span class="bold">Frequency:</span>
                        </div>
                        <div class="col s12 m6 l6 xl7 remove-default-padding">
                          {{dataItem.frequency}}
                        </div>
                      </div>
                      <div class="row bottom-margin-0">
                        <div class="col s12 m6 l6 xl5 remove-default-padding">
                          <span class="bold">Location(s):</span>
                        </div>
                        <div class="col s12 m6 l6 xl7 remove-default-padding">
                          {{dataItem.locations}}
                        </div>
                      </div>
                      <div class="row bottom-margin-0">
                        <div class="col s12 m6 l6 xl5 remove-default-padding">
                          <span class="bold">System(s):</span>
                        </div>
                        <div class="col s12 m6 l6 xl7 remove-default-padding">
                          {{dataItem.systems}}
                        </div>
                      </div>
                      <div class="row bottom-margin-0">
                        <div class="col s12 m6 l6 xl5 remove-default-padding">
                          <span class="bold">Total Pays:</span>
                        </div>
                        <div class="col s12 m6 l6 xl7 remove-default-padding">
                          {{dataItem.payCount}}
                        </div>
                      </div>
                      <div class="row bottom-margin-0">
                        <div class="col s12 m6 l6 xl5 remove-default-padding">
                          <span class="bold">Contributory Pays:</span>
                        </div>
                        <div class="col s12 m6 l6 xl7 remove-default-padding">
                          {{dataItem.contributoryCount}}
                        </div>
                      </div>
                      <div [ngSwitch]="item.id" class="align-right">
                        <!-- show links for lfy -->
                        <div class="row" *ngSwitchCase="this.lfy">
                          <div class="col s12 m12 l12" *ngIf="operators.View">
                            <span class="k-icon k-i-eye link-icon"></span>
                            <a class="clone-link" href="javascript: void(0)"
                              (click)="loadScheduleDetails(dataItem,'View')">View</a>
                          </div>
                        </div>
                        <!-- show links for cfy -->
                        <div id="currentYearButton" *ngSwitchCase="this.cfy" class="row inline-flex-display">
                          <div *ngIf="operators.Delete" class="align-action">
                            <span class="k-icon k-i-delete link-icon top-margin-3"></span>
                            <a class="clone-link" href="javascript: void(0)" title="Delete this Schedule"
                              (click)="loadScheduleDetails(dataItem,'Delete')">Delete</a>
                          </div>
                          <div *ngIf="operators.Edit" class="align-action">
                            <span class="k-icon k-i-edit link-icon left-margin-5 top-margin-3"></span>
                            <a class="clone-link" href="javascript: void(0)" title="Edit this Schedule"
                              (click)="EditSchedule(dataItem)">Edit</a>
                          </div>
                          <!-- show new link based on partialFlag -->
                          <div [ngSwitch]="dataItem.partialFlag" class="inline-flex-display" *ngIf="operators.Add">
                            <span class="k-icon k-i-forward-sm link-icon left-margin-5 top-margin-3"></span>
                            <div *ngSwitchCase="1">
                              <!--PARTIAL SCHEDULE-->
                              <a class="clone-link disable-link" href="javascript: void(0)"
                                title="This partial schedule was already forwarded.">Continue</a>
                            </div>
                            <div *ngSwitchCase="3">
                              <a class="clone-link" href="javascript: void(0)"
                                (click)="continueSchedule(dataItem, 'ContinuePartial');" title="Continue this partial schedule from Fiscal Year {{dataItem.fiscalYear}}, final Pay
                            Period End Date of {{item.finalPPED}}">Continue</a>
                            </div>
                            <!--FULL SCHEDULE-->
                            <div *ngSwitchCase="2">
                              <a class="clone-link disable-link" href="javascript: void(0)"
                                title="This schedule was already forwarded.">Continue</a>
                            </div>
                            <div *ngSwitchCase="4">
                              <a class="clone-link" href="javascript: void(0)" title="Continue this schedule from Fiscal Year {{dataItem.fiscalYear}}, final Pay Period End
                          Date of {{item.finalPPED}}" (click)="continueSchedule(dataItem,
                          'ContinueSchedule');">Continue</a>
                            </div>
                          </div>
                          <span class="k-icon k-i-eye link-icon left-margin-5 top-margin-3"></span>
                          <a class="clone-link" href="javascript: void(0)"
                            (click)="loadScheduleDetails(dataItem,'View')">View</a>
                        </div>
                        <!-- show links for nfy -->
                        <div class="row inline-flex-display" *ngSwitchCase="this.nfy">
                          <div *ngIf="operators.Delete">
                            <span class="k-icon k-i-delete link-icon"></span>
                            <a class="clone-link" href="javascript: void(0)" title="Delete this Schedule"
                              (click)="loadScheduleDetails(dataItem,'Delete')">Delete</a>
                          </div>
                          <div *ngIf="operators.Edit">
                            <span class="k-icon k-i-edit link-icon left-margin-5"></span>
                            <a class="clone-link" href="javascript: void(0)" title="Edit this Schedule"
                              (click)="EditSchedule(dataItem)">Edit</a>
                          </div>
                          <div *ngIf="operators.View">
                            <span class="k-icon k-i-eye link-icon left-margin-5"></span>
                            <a class="clone-link" href="javascript: void(0)"
                              (click)="loadScheduleDetails(dataItem,'View')">View</a>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </kendo-panelbar-item>
                </kendo-panelbar>
              </div>
            </ng-template>
          </kendo-tabstrip-tab>
        </kendo-tabstrip>
      </div>
    </div>
  </div>
  <div class="col s12 m12 l8 xl9" id="scheduleDetails">
    <app-create-schedule *ngIf="isNewScheduleValid && displayChild" [type]="actionType" [scheduleInput]="scheduleInput"
      [scheduleId]="selectedScheduleId" [scheduleHistory]="schedulehistry"
      (closeCreateSchedule)="scheduleUpdate($event)" (changed)="changesMade($event)">
    </app-create-schedule>
    <app-delete-schedule *ngIf="isDeleteScheduleValid && displayChild" [scheduleId]="selectedScheduleId"
      (closedeleteDialog)="recieveDeleteEvent($event)" [configText]="configText">
    </app-delete-schedule>
    <app-schedule-details *ngIf="isLoadScheduleValid && displayChild" (close)="isLoadScheduleValid = false"
      [scheduleId]="selectedScheduleId" [actionType]="actionType" [scheduleHistory]="schedulehistry"
      [employerSchId]="empScheduleId" [orgName]="orgName" (successResult)="displayResult($event)"
      [userActionData]="accessData">
    </app-schedule-details>
  </div>
</div>
<app-notification-loading></app-notification-loading>
